import { TitleCasePipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'


@Pipe({
    name: 'enumtitlecase',
    pure: true
})
export class EnumTitleCasePipe implements PipeTransform {
    titleCase: TitleCasePipe

    constructor(tileCase: TitleCasePipe) {
        this.titleCase = tileCase
    }

    transform(value: string): string {
        return this.titleCase.transform(value.replace(/_/g, ' '))
    }
}
